module.exports = __webpack_public_path__ + "img/p24.59ec2d68.svg";